/* This file is automatically generated for @graphcommerce/graphql */

export * from '.'
import { Plugin as HygraphGraphqlProvider } from '@graphcommerce/graphcms-ui/plugins/HygraphGraphqlProvider'
import { Plugin as MagentoCartGraphqlProvider } from '@graphcommerce/magento-cart/plugins/MagentoCartGraphqlProvider'
import { Plugin as MagentoCustomerGraphqlProvider } from '@graphcommerce/magento-customer/plugins/MagentoCustomerGraphqlProvider'
import { Plugin as MagentoGraphqlGraphqlProvider } from '@graphcommerce/magento-graphql/plugins/MagentoGraphqlGraphqlProvider'
import { Plugin as MagentoStoreGraphqlProvider } from '@graphcommerce/magento-store/plugins/MagentoStoreGraphqlProvider'
import { Plugin as MagentoWishlistGraphqlProvider } from '@graphcommerce/magento-wishlist/plugins/MagentoWishlistGraphqlProvider'
import { ComponentProps } from 'react'
import { GraphQLProvider as GraphQLProviderBase } from '.'

/**
 * Interceptor for `<GraphQLProvider/>` with these plugins:
 * 
 * - `@graphcommerce/magento-graphql/plugins/MagentoGraphqlGraphqlProvider`
 * - `@graphcommerce/magento-store/plugins/MagentoStoreGraphqlProvider`
 * - `@graphcommerce/magento-customer/plugins/MagentoCustomerGraphqlProvider`
 * - `@graphcommerce/magento-cart/plugins/MagentoCartGraphqlProvider`
 * - `@graphcommerce/magento-wishlist/plugins/MagentoWishlistGraphqlProvider`
 * - `@graphcommerce/graphcms-ui/plugins/HygraphGraphqlProvider`
 */
type GraphQLProviderProps = ComponentProps<typeof GraphQLProviderBase>

function MagentoGraphqlGraphqlProviderInterceptor(props: GraphQLProviderProps) {
  return <MagentoGraphqlGraphqlProvider {...props} Prev={GraphQLProviderBase} />
}
function MagentoStoreGraphqlProviderInterceptor(props: GraphQLProviderProps) {
  return <MagentoStoreGraphqlProvider {...props} Prev={MagentoGraphqlGraphqlProviderInterceptor} />
}
function MagentoCustomerGraphqlProviderInterceptor(props: GraphQLProviderProps) {
  return <MagentoCustomerGraphqlProvider {...props} Prev={MagentoStoreGraphqlProviderInterceptor} />
}
function MagentoCartGraphqlProviderInterceptor(props: GraphQLProviderProps) {
  return <MagentoCartGraphqlProvider {...props} Prev={MagentoCustomerGraphqlProviderInterceptor} />
}
function MagentoWishlistGraphqlProviderInterceptor(props: GraphQLProviderProps) {
  return <MagentoWishlistGraphqlProvider {...props} Prev={MagentoCartGraphqlProviderInterceptor} />
}
function HygraphGraphqlProviderInterceptor(props: GraphQLProviderProps) {
  return <HygraphGraphqlProvider {...props} Prev={MagentoWishlistGraphqlProviderInterceptor} />
}
export const GraphQLProvider = HygraphGraphqlProviderInterceptor
